/* eslint-disable no-restricted-syntax */
import { IFieldOption } from 'store/field-options/types';

/**
 * Takes a field option name and returns the display name (if found)
 * @param name
 * @param fieldOptionArray
 * @returns Display name (if found)
 */
export function mapNameToDisplayName(name?: string, fieldOptions?: IFieldOption[]): string {
  if (!name) {
    return '';
  }

  if (!fieldOptions) {
    return name;
  }

  let returnValue = name;
  for (const fieldOption of fieldOptions) {
    if (fieldOption.name === name) {
      returnValue = fieldOption.displayName;
      break;
    }
  }
  return returnValue;
}
